const lang =
    {
        'ja': {
            'delete_default': 'Pokekaraのアカウントを削除されることを大変残念に思います。'
        },
        'zh-hans': {
            /*
            'delete_default': '知晓您要删除账号，我们感到非常抱歉'
             */
        }
    };

export { lang };